// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-billing-header .fi-tabs {
  display: block;
  border-top: 1px solid var(--fi-border-color-extra-light);
}`, "",{"version":3,"sources":["webpack://./Source/app/billing/billing-header/billing-header.component.scss"],"names":[],"mappings":"AACI;EACI,cAAA;EACA,wDAAA;AAAR","sourcesContent":[".fi-billing-header {\r\n    .fi-tabs {\r\n        display: block;\r\n        border-top: 1px solid var(--fi-border-color-extra-light);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
